import { DashboardView, TeamCalendarView, TeammatesScope } from '../types'

export interface DashboardPreferences {
  pinnedView: DashboardView | null
  teammatesScope: TeammatesScope
  teamCalendarView: TeamCalendarView
  leavesThisWeekLeaveTypeIds: string[]
  leavesThisWeekDepartmentIds: string[]
}

export const DASHBOARD_PREFERENCES_KEY = 'vt-dashboard-preferences'

const DEFAULT_PREFERENCES: DashboardPreferences = {
  pinnedView: null,
  teammatesScope: 'department',
  teamCalendarView: 'distribution',
  leavesThisWeekLeaveTypeIds: [],
  leavesThisWeekDepartmentIds: [],
}

export const getDashboardPreferences = (): DashboardPreferences => {
  try {
    const stored = localStorage.getItem(DASHBOARD_PREFERENCES_KEY)
    if (stored) {
      return { ...DEFAULT_PREFERENCES, ...JSON.parse(stored) }
    }
  } catch {
    // ignore
  }
  // Copy - callers (updateDashboardPreference) mutate the returned object, and
  // handing out the shared default would corrupt it for the rest of the session.
  return { ...DEFAULT_PREFERENCES }
}

export const updateDashboardPreference = <K extends keyof DashboardPreferences>(key: K, value: DashboardPreferences[K]): DashboardPreferences => {
  const prefs = getDashboardPreferences()
  prefs[key] = value
  try {
    localStorage.setItem(DASHBOARD_PREFERENCES_KEY, JSON.stringify(prefs))
  } catch {
    // ignore
  }
  return prefs
}
